package anjuros.development.modules

import anjuros.development.components.language.ResKey

enum class Section(
    val id: String,
    val subtitle: ResKey,
    val path: String
) {

    Rooms(
        id = "rooms",
        subtitle = ResKey.SECTION_ROOMS,
        path = "#rooms"
    ),


    Reviews(
        id = "reviews",
        subtitle = ResKey.SECTION_REVIEWS,
        path = "#reviews"
    ),
    Nearby(
        id = "nearby",
        subtitle = ResKey.SECTION_NEARBY,
        path = "#nearby"
    ),
    Facilities(
        id = "facilities",
        subtitle = ResKey.SECTION_FACILITIES,
        path = "#facilities"
    ),
    FAQ(
        id = "faq",
        subtitle = ResKey.SECTION_FAQ,
        path = "#faq"
    )
}